export default "__VITE_ASSET__BIjLZjA5__"